import { forwardRef, InputHTMLAttributes } from 'react';

import InlineSvg from 'approot/shared/inline-svg/inline-svg';
import IconPlus from 'approot/shared/icons/icon-plus';
import { StepInputStyled, StepInputButtonStyled } from './step-input.style';

type Props = {
  onDecrementClick: () => void;
  onIncrementClick: () => void;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  'data-selector'?: string;
  $hasError?: boolean;
  incrementLabel?: string;
  decrementLabel?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'type'>;

const StepInput = forwardRef<HTMLInputElement | null, Props>(
  (
    {
      onDecrementClick,
      onIncrementClick,
      isDecrementDisabled,
      isIncrementDisabled,
      incrementLabel,
      decrementLabel,
      ...inputProps
    }: Props,
    ref
  ) => {
    return (
      <>
        {!isDecrementDisabled && (
          <StepInputButtonStyled
            aria-label="Decrease total"
            onClick={onDecrementClick}
            type="button"
            data-selector="decrement"
          >
            <InlineSvg id="icon_minus" width={9} height={9} />
          </StepInputButtonStyled>
        )}
        <StepInputStyled ref={ref as any} {...inputProps} />
        {!isIncrementDisabled && (
          <StepInputButtonStyled
            aria-label="Increase total"
            onClick={onIncrementClick}
            type="button"
            data-selector="increment"
          >
            <IconPlus width={9} height={9} />
          </StepInputButtonStyled>
        )}
      </>
    );
  }
);

export default StepInput;
